export function routes () {
    return [
        {
            name: 'payment.list',
            path: '/tienda/pagos',
            component: () => import(/* webpackChunkName: "payment-list.component" */'@/modules/payment/components/PaymentList.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Pagos online',
                module: 'shop.payments',
                vuex: {
                    loadModules: ['payment'],
                },
            },
            children: [
                {
                    name: 'payment.detail',
                    path: 'detalle/:id',
                    component: () => import(/* webpackChunkName: "payment-detail.component" */ '@/modules/payment/components/PaymentDetail.vue'),
                    meta: {
                        toolbarTitle: 'Pagos online',
                        module: 'shop.payments.payment',
                        vuex: {
                            loadModules: ['payment'],
                        },
                    },
                },
            ],
        },
    ]
}
